// Webpack Imports

import * as bootstrap from 'bootstrap';
import './blocks/_homepage-factions';
import './blocks/_latest-news';
import './blocks/_need-help';
import './blocks/_video-modal';
import './blocks/_carousel';
import './blocks/_sticky-nav';
import './blocks/_factions';
import './blocks/_buy';
import './components/_news';
import './components/_newsletter';

( function () {
	'use strict';

	if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
		// the user is using a mobile device, so redirect to the mobile version of the website
		$('body').addClass('mobile');
	}

} )();

